<div class="callout-hint callout {{class}}" [class.hint-hover]="clickTarget !== null" [class.internal]="isInternalPortal">
  <div class="cell hint-wrapper" (click)="clickTarget !== null ? onClickToLeadModule() : null">
    <div class="icon-wrapper" *ngIf="showPdfAndPrintIcons">
      <i class="icon-print" ></i>
      <i class="icon-pdf"></i>
    </div>
    <p [innerHTML]="textkey | translate"></p>
  </div>
  <button class="close-button" aria-label="schliessen" type="button" (click)="closeHint()">
    <i class="icon-x"></i>
  </button>
</div>
